import DataTypes from './DataTypes'

/* eslint-disable */
const SolumaBatchTypes = {
  APP_FOLDER: '',
	FILE_NAME: '',
  dialog: false,
	BatchTypes: [
	],
  BatchTypeJSON: null,
  General: {
    Lang: 'en',
    BatchDeleteTime: 14,
    rgba: { r: 0, g: 0, b: 0, a: 1 },
    CreateBatchAuto: false,
    AllowedExtensions: [],
    Params: [],
    BatchProperties: [],
    EndpointSettings: {
      Endpoint: '',
      UserName: '',
      Password: '',
      PasswordCrypt: '',
      showPass: false,
      Type: 'STANDARD',
      SessionID: '',
      AUTH: '',
      Headers: '',
      ConfirmDialog: false,
      SkipExportSettings: false
    },
    SimSettings: {
      Endpoint: '',
      UserName: '',
      Password: '',
      PasswordCrypt: '',
      showPass: false,
      Disabled: true,
      Exchange: false,
      SkipExportSettings: true
    },
    EndpointMFiles: {
      BaseUrl: '',
      ObjectId: '',
      VaultId: '',
      AutoDownload: false,
      AutoNewBatch: false,
      username: '',
      password: '',
      showPass: false,
      AuthType: 'auto',
      SkipExportSettings: false,
      RequiredClassification: false,
      CreationDialog: false
    },
    EndpointMonday: {
      SkipExportSettings: false
    }
  },
  get Current () {
    if(this.BatchTypeJSON !== null) return this.BatchTypeJSON
    const found = this.BatchTypes.find(b => b.Selected === true)
    if (found !== null && found !== undefined) return found
    return this.BatchTypes[0]
  }
}

export const isExportEndPoint = () => {
  const batchType = SolumaBatchTypes.Current
  // console.log(SolumaBatchTypes.General.EndpointSettings.Endpoint)
  // console.log(batchType)
  if (SolumaBatchTypes.General.EndpointSettings.Endpoint.trim().length > 0 || batchType.EndpointSettings.Endpoint.trim().length > 0) {
    return true
  } else {
    return false
  }
}

export const BatchParams = () => {
  const batchType = SolumaBatchTypes.Current
  const params = [...batchType.BatchSettings.Params]
  // const params = batchType.BatchSettings.Params
  for (let i = 0; i < SolumaBatchTypes.General.Params.length; ++i) {
    const param = SolumaBatchTypes.General.Params[i]
    const found = params.find(p => p.Name === param.Name)
    if (!found) {
      params.push(param)
    }
  }
  return params
}

export const BatchProperties = () => {
  const batchType = SolumaBatchTypes.Current
  const properties = [...batchType.BatchSettings.BatchProperties]
  for (let i = 0; i < SolumaBatchTypes.General.BatchProperties.length; ++i) {
    const prop = SolumaBatchTypes.General.BatchProperties[i]
    const found = properties.find(p => p.Name === prop.Name)
    if (!found) {
      properties.push(prop)
    }
  }
  return properties
}


class BatchTypeModel {
    constructor() {
    }
    static getModel() {
        return {
            Selected: true,
            Name: '',
            Id: '',
            ApplicationSettings: {
                ExportSettings: {
                  ExportFolder: '',
                  Format: 'PDF',
                  Depth: 'BlackWhite',
                  Quality: 10,
                  Compression: 'Group4',
                  Skip: false,
                  CreateNewBatchDialog: true, // show create batch dialog if CreateBatchAuto=false
                  CreateNewBatchAuto: false, // create new batch automatically after batch export
                  AutoCloseWindow: false // close window automatically after export batch
                },
                ImportSettings: {
                  ImportFolder: '',
                  ForceImportFolder: false,
                  DeleteFileAfterImport: false,
                  Attachments: false
                },
                ScanSettings: {
                    Duplex: false,
                    DPI: 300,
                    Depth: 'BlackWhite',
                    Size: 'A4',
                    BarcodeSeparator: false,
                    BarcodeRegexp: '',
                    BarcodeModel: 'SDTBARCODETYPE_ALL_1D',
                    AutoSeparator: false,
                    AutoSinglePageDocuments: true,
                    FileSeparator: false,
                    BarcodeDirection: 'SDTREADDIRECTION_LTR',
                    BarcodeArea: 'TOP_1_3',
                    DoubleDetection: false
                },
                BatchDeleteTime: 14
            },
            EndpointSettings: {
              Endpoint: '',
              Type: 'STANDARD',
              SessionID: '',
              AUTH: '',
              Headers: '',
              ConfirmDialog: false,
              SkipExportSettings: false,
              Populate: false
            },
            SimSettings: {
              Endpoint: 'https://sim.solumainvoicereader.com/rs/admin/recognitionUpload',
              SkipExportSettings: true
            },
            LanguageSettings: {
              Lang: 'en'
            },
            TwainDevice: null,
            BatchSettings: {
              Quick: false,
              SessionId: '',
              Params: [],
              BatchProperties: [],
              Classes: [],
              Indexes: [],
              StatusBar: { Color: 'primary lighten1', Info: '' }
            },
            EndpointMFiles: {
              BaseUrl: '',
              ObjectId: '',
              VaultId: '',
              AutoDownload: false,
              AutoNewBatch: false,
              username: '',
              password: '',
              AuthType: 'auto',
              SkipExportSettings: false,
              Populate: false,
              RequiredClassification: false,
              CreationDialog: false
            },
            EndpointMonday: {
              SkipExportSettings: false,
              Populate: false
            }
        }
    }
}

class JsonURLParser {
  constructor (app, batchTypes, json) {
    this.dth = new DataTypes()
    this.app = app
    this.batchTypes = batchTypes
    this.json = json
  }

  populateProperties = (prop, fromProp) => {
    for (let p in prop) {
      if (!this.dth.isNullOrUndefined(fromProp[p])) {
        prop[p] = fromProp[p]
      }
    }
  }

  convertValue = (value, datatype, prop) => {
    try {
      if (datatype.toLowerCase() === 'number') {
        return parseInt(value)
      }
      if (datatype.toLowerCase() === 'boolean' || datatype.toLowerCase() === 'bool') {
        if (typeof value === 'string'){
          value = value.trim().toLowerCase();
        }
        switch(value){
            case true:
            case 'true':
            case 1:
            case '1':
            case 'on':
            case 'yes':
                return true
            default:
                return false
        }
      }
      if (datatype.toLowerCase() === 'string') {
        return value.toString()
      }
    } catch(err) {
      this.app.alert = true
      this.app.alertMessage = 'JsonURLParser.convertValue(' + value + ',' + datatype + ',' + prop + ') ERROR:' + err.toString()
      return value
    }
  }

  parseJSON =  (json) => {
    try {
      console.log('parseJSON()', json)
      if (json !== null || json === undefined) {
        json = this.json
      }
      this.app.batchTypes.BatchTypeJSON = BatchTypeModel.getModel()
      const batchType = this.app.batchTypes.BatchTypeJSON
      batchType.Name = 'Json Url Batch Type'
      batchType.Id = 'json_url_type_' + Math.floor(Math.random() * 100000)
      this.app.selectedBatchTypeId = batchType.Id

      // check if JSON url is new model
      if (json.ApplicationSettings !== null && json.ApplicationSettings !== undefined) {
        if (json.ApplicationSettings) {
          if(json.ApplicationSettings.ExportSettings) this.populateProperties(batchType.ApplicationSettings.ExportSettings, json.ApplicationSettings.ExportSettings)
          if(json.ApplicationSettings.ImportSettings) {
            this.populateProperties(batchType.ApplicationSettings.ImportSettings, json.ApplicationSettings.ImportSettings)
            this.app.importFolderCheckBox = (batchType.ApplicationSettings.ImportSettings.ForceImportFolder === true) ? true : false
          }
          if(json.ApplicationSettings.ScanSettings) this.populateProperties(batchType.ApplicationSettings.ScanSettings, json.ApplicationSettings.ScanSettings)
        }
        if (json.BatchSettings) { this.populateProperties(batchType.BatchSettings, json.BatchSettings) }
        if (json.SimSettings) { this.populateProperties(batchType.SimSettings, json.SimSettings) }
        if (json.EndpointSettings) { this.populateProperties(batchType.EndpointSettings, json.EndpointSettings) }
        if (json.EndpointMFiles) { this.populateProperties(batchType.EndpointMFiles, json.EndpointMFiles) }
        if (json.LanguageSettings) {
          SolumaBatchTypes.General.Lang = json.LanguageSettings.Lang
          this.populateProperties(batchType.LanguageSettings, json.LanguageSettings)
        }
        if (json.Quick || json.BatchSettings.Quick) {
          batchType.BatchSettings.Quick = (json.Quick) ? json.Quick : json.BatchSettings.Quick
        }
      } else {
        console.log('PARSE OLD MODEL JSON URL')
        if (json.EndpointMFiles) { this.populateProperties(batchType.EndpointMFiles, json.EndpointMFiles) }
        if (json.Classes) { batchType.BatchSettings.Classes.push(...json.Classes) }
        if (json.Params) { batchType.BatchSettings.Params.push(...json.Params) }
        if (json.BatchProperties) { batchType.BatchSettings.BatchProperties.push(...json.BatchProperties) }
        if (json.Indexes) { batchType.BatchSettings.Indexes.push(...json.Indexes) }
        if (json.Quick) { batchType.BatchSettings.Quick = json.Quick }
        if (json.StatusBar) { this.populateProperties(batchType.BatchSettings.StatusBar, json.StatusBar) }
        if (json.ExportEndPoint) {
          for (let endpointProp in batchType.EndpointSettings) {
            const found = json.ExportEndPoint.find(s => endpointProp.toLowerCase() === s.Name.toLowerCase())
            if (found) {
              let dataType = found.DataType
              if (endpointProp === 'ConfirmDialog') { dataType = 'boolean' }
              const val = this.convertValue(found.Value, dataType, found.Name)
              batchType.EndpointSettings[endpointProp] = val
            }
          }
        }
        if (json.Settings) {
          for (let importProp in batchType.ApplicationSettings.ImportSettings) {
            let found = json.Settings.find(s => importProp.toLowerCase() === s.Name.toLowerCase())
            if (!found) found = json.Settings.find(s => ('ImportSettings' + importProp).toLowerCase() === s.Name.toLowerCase())
            if (found) {
              const val = this.convertValue(found.Value, found.DataType, found.Name)
              batchType.ApplicationSettings.ImportSettings[importProp] = val
            }
          }
          for (let scanProp in batchType.ApplicationSettings.ScanSettings) {
            let found = json.Settings.find(s => scanProp.toLowerCase() === s.Name.toLowerCase())
            if (!found) found = json.Settings.find(s => ('ScanSettings' + scanProp).toLowerCase() === s.Name.toLowerCase())
            if (found) {
              const val = this.convertValue(found.Value, found.DataType, found.Name)
              batchType.ApplicationSettings.ScanSettings[scanProp] = val
            }
          }
          // check scan settings if singlepages is True and another one separator is True
          const scanPropList = ['AutoSeparator', 'FileSeparator', 'BarcodeSeparator']
          scanPropList.forEach(sp => {
            if (batchType.ApplicationSettings.ScanSettings[sp] === true) {
              batchType.ApplicationSettings.ScanSettings.AutoSinglePageDocuments = false
            }
          })
          for (let exportProp in batchType.ApplicationSettings.ExportSettings) {
            let found = json.Settings.find(s => exportProp.toLowerCase() === s.Name.toLowerCase())
            if (!found) found = json.Settings.find(s => ('ExportSettings' + exportProp).toLowerCase() === s.Name.toLowerCase())
            if (found) {
              let dataType = found.DataType
              if (exportProp === 'Skip') { dataType = 'boolean' }
              const val = this.convertValue(found.Value, dataType, found.Name)
              batchType.ApplicationSettings.ExportSettings[exportProp] = val
            }
          }
        }
      }
    } catch (err) {
      this.app.alert = true
      this.app.alertMessage = 'JsonURLParser.parseJSON ERROR:' + err.toString()
    }
  }
}

SolumaBatchTypes.BatchTypes.push(BatchTypeModel.getModel())
export default SolumaBatchTypes
export { BatchTypeModel, JsonURLParser }
